import FolderName from './FolderName'
export default FolderName;